export interface NotificationUserFollowerInterface {
  readAt: Date;
  notificationId: string;
  followingStartDate: Date;
  followerImageUrl: string;
  followerUserName: string;
}
